import styled from 'styled-components';
import AgreementModal from './AgreementModal';
import AlarmModal from '../components/AlarmModal';
import LoadingModal from '../components/LoadingModal';
import { useState, useRef, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Config } from '../config';
import emailjs from 'emailjs-com';

const Contact = () => {
    const [company, setCompany] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [contactText, setContactText] = useState<string>('');
    const [alarmModalText, setAlarmModalText] = useState<string>('');
    const [agreementModalState, setAgreementModalState] = useState(false);
    const [alarmModalState, setAlarmModalState] = useState(false);
    const [loadingModalState, setLoadingModalState] = useState(false);

    type TemplateParams = {
        company: string;
        name: string;
        phoneNumber: string;
        email: string;
        contactText: string;
    };

    const agreementRef = useRef<HTMLInputElement>(null);

    const handleAgreementModalClose = () => {
        setAgreementModalState(false);
        document.body.classList.remove('active');
    }

    const handleAlarmModalClose = () => {
        setAlarmModalState(false);
        document.body.classList.remove('active');
    }

    const handleSubmit = async () => {
        if (company.trim() === '' || name.trim() === '' || phoneNumber.trim() === '' || email.trim() === '' || contactText.trim() === '') {
            document.body.classList.add('active');
            setAlarmModalState(true);
            setAlarmModalText('빈 칸을 확인해 주세요.');
            return;
        }

        if (agreementRef.current) {
            if (!agreementRef.current.checked) {
                document.body.classList.add('active');
                setAlarmModalState(true);
                setAlarmModalText('개인정보 수집 및 이용을 동의해 주세요.');
                return;
            }
        }        

        setLoadingModalState(true);

        const templateParams: TemplateParams = {
            company,
            name,
            phoneNumber,
            email,
            contactText,
        };

        emailjs.send(String(Config.EMAILJS_SERVICE_KEY), String(Config.EMAILJS_TEMPLATE_KEY), templateParams, String(Config.EMAILJS_USER_KEY))
        .then((result) => {
            document.body.classList.add('active');
            setLoadingModalState(false);
            setAlarmModalState(true);
            setAlarmModalText('문의 내용이 성공적으로 전송되었습니다.');
            setCompany('');
            setName('');
            setPhoneNumber('');
            setEmail('');
            setContactText('');
            if (agreementRef.current) {
                agreementRef.current.checked = false;
            }
        }, (error) => {
            document.body.classList.add('active');
            setLoadingModalState(false);
            setAlarmModalState(true);
            setAlarmModalText('문의 내용의 전송이 실패되었습니다. \n잠시 후 다시 시도하거나, 관리자에게 문의해 주세요.');
        });
    }

    useEffect(() => {
        AOS.init({
            duration: 800,
            offset: 0,
        });
    }, []);

    return (
        <>
            <Wrap>
                <div className="con rel">
                    <span className="bg-img-box img-box abs zi1 x-middle">
                        <img src="./img/contact_bg_img_1.svg" alt="" data-aos="fade" data-aos-delay="300"/>
                    </span>
                    <h1 className='tb tac' data-aos="fade" data-aos-delay="500"><span className='tb inblock'>맞춤형 증명 서비스</span>를 <br/>도입해보세요.</h1>
                    <ContactBox className='flex rel zi2' data-aos="fade-up" data-aos-delay="900">
                        <div className="left-box">
                            <ul className='flex fdc'>
                                <li className='flex fdc'>
                                    <h3 className='lh140 tsb'>회사명 및 소속</h3>
                                    <input type="text" placeholder='회사명 및 소속을 입력해 주세요.' value={company} onChange={(e) => setCompany(e.target.value)}/>
                                </li>
                                <li className='flex fdc'>
                                    <h3 className='lh140 tsb'>성함</h3>
                                    <input type="text" placeholder='성함을 입력해 주세요.' value={name} onChange={(e) => setName(e.target.value)}/>
                                </li>
                                <li className='flex fdc'>
                                    <h3 className='lh140 tsb'>연락처</h3>
                                    <input type="text" placeholder='연락처를 입력해 주세요.' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}/>
                                </li>
                                <li className='flex fdc'>
                                    <h3 className='lh140 tsb'>이메일</h3>
                                    <input type="text" placeholder='이메일을 입력해 주세요.' value={email} onChange={(e) => setEmail(e.target.value)}/>
                                </li>
                                <li className='flex fdc'>
                                    <h3 className='lh140 tsb'>문의내용</h3>
                                    <textarea placeholder='문의내용을 입력해 주세요.' value={contactText} onChange={(e) => setContactText(e.target.value)}></textarea>
                                </li>
                            </ul>
                            <div className="agreement-box flex aic">
                                <div className="input-box">
                                    <input type="checkbox" id='agreement' ref={agreementRef}/>
                                    <label htmlFor='agreement' className='flex aic cp'>
                                        <span className="img-box">
                                            <img src="./img/check_img_1.svg" alt="" />
                                        </span>
                                        <span className="text tm lh140">[필수] 개인정보 수집 및 이용에 동의합니다.</span>
                                    </label>
                                </div>
                                <button
                                    className='tm lh140 tdu'
                                    onClick={() => {
                                        setAgreementModalState(true)
                                        document.body.classList.add('active')
                                    }}>전문</button>
                            </div>
                            <button className='submit-btn flex jcc aic' onClick={handleSubmit}>도입 문의하기</button>
                        </div>
                        <div className="right-box">
                            <p className='tb'>
                                누구 하나 불편함 없이,<br/>
                                걱정없이 맡길 수 있도록<br/>
                                고객님들의 니즈에 맞춰<br/>
                                발걸음 하는 KEY-MINE 입니다.
                            </p>
                        </div>
                    </ContactBox>
                </div>
            </Wrap>
            {agreementModalState &&
                <AgreementModal onClose={handleAgreementModalClose}/>
            }
            {alarmModalState &&
                <AlarmModal modalText={alarmModalText} onClose={handleAlarmModalClose}/>
            }
            {loadingModalState &&
                <LoadingModal/>
            }
        </>
    );
}

export default Contact;

const Wrap = styled.div`
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 100px 0;
    @media (max-width: 1400px) {
        padding: 7.1428vw 0;
    }
    @media (max-width: 767px) {
        padding: 50px 0 100px 0;
    }

    .bg-img-box {
        width: 1871px;
        bottom: -29px;
        @media (max-width: 1920px) {
            width: 97.4479vw;
            bottom: -1.5104vw;
        }
        @media (max-width: 767px) {
            width: 105%;
            bottom: -29px;
        }
    }

    h1 {
        font-size: 55px;
        line-height: 60px;
        color: #282828;
        @media (max-width: 1400px) {
            font-size: 3.9285vw;
            line-height: 4.2857vw;
        }
        @media (max-width: 767px) {
            font-size: 30px;
            line-height: 40px;
        }
        
        > span {
            line-height: 60px;
            color: ${props => props.theme.mainColor1};
            @media (max-width: 1400px) {
                line-height: 4.2857vw;
            }
            @media (max-width: 767px) {
                line-height: 40px;
            }
        }

        > br {
            display: none;
            @media (max-width: 767px) {
                display: block;
            }
        }
    }
`
const ContactBox = styled.div`
    margin-top: 40px;
    border-radius: 20px;
    overflow: hidden;
    @media (max-width: 1400px) {
        margin-top: 2.8571vw;
        border-radius: 1.4285vw;
    }
    @media (max-width: 767px) {
        margin-top: 24px;
        border-radius: 20px;
        flex-direction: column-reverse;
    }

    .left-box {
        width: 61%;
        box-sizing: border-box;
        padding: 40px;
        background-color: rgba(0, 0, 0, 0.1);
        @media (max-width: 1400px) {
            padding: 2.8571vw;
        }
        @media (max-width: 767px) {
            width: 100%;
            padding: 24px;
        }

        > ul {
            gap: 24px;
            @media (max-width: 1400px) {
                gap: 1.7142vw;
            }
            @media (max-width: 767px) {
                gap: 24px;
            }

            > li {
                gap: 8px;
                @media (max-width: 1400px) {
                    gap: 0.5714vw;
                }
                @media (max-width: 767px) {
                    gap: 8px;
                }

                > h3 {
                    font-size: 16px;
                    color: #282828;
                    @media (max-width: 1400px) {
                        font-size: 1.1428vw;
                    }
                    @media (max-width: 767px) {
                        font-size: 16px;
                    }
                }

                > input {
                    width: 100%;
                    height: 48px;
                    box-sizing: border-box;
                    padding: 0 4px;
                    border: none;
                    border-bottom: 1px solid #282828;
                    background-color: transparent;
                    font-size: 14px;
                    color: #282828;
                    line-height: 20px;
                    &::placeholder {
                        color: #878787;
                    }
                    @media (max-width: 1400px) {
                        height: 3.4285vw;
                        padding: 0 0.2857vw;
                        font-size: 1vw;
                        line-height: 1.4285vw;
                    }
                    @media (max-width: 767px) {
                        height: 48px;
                        padding: 0 4px;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }

                > textarea {
                    width: 100%;
                    height: 136px;
                    box-sizing: border-box;
                    padding: 6px 4px;
                    border: none;
                    border-bottom: 1px solid #282828;
                    background-color: transparent;
                    font-size: 14px;
                    color: #282828;
                    line-height: 20px;
                    &::placeholder {
                        color: #878787;
                    }
                    @media (max-width: 1400px) {
                        height: 9.7142vw;
                        padding: 0.4285vw 0.2857vw;
                        font-size: 1vw;
                        line-height: 1.4285vw;
                    }
                    @media (max-width: 767px) {
                        height: 136px;
                        padding: 6px 4px;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }

        .agreement-box {
            margin-top: 24px;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
            }
            @media (max-width: 767px) {
                margin-top: 16px;
            }

            .input-box {
                > input {
                    display: none;
                }

                > label {
                    gap: 8px;
                    @media (max-width: 1400px) {
                        gap: 0.5714vw;
                    }
                    @media (max-width: 767px) {
                        gap: 6px;
                    }
                    
                    > .img-box {
                        width: 16px;
                        @media (max-width: 1400px) {
                            width: 1.1428vw;
                        }
                        @media (max-width: 767px) {
                            width: 12px;
                        }
                    }

                    > .text {
                        font-size: 16px;
                        @media (max-width: 1400px) {
                            font-size: 1.1428vw;
                        }
                        @media (max-width: 767px) {
                            font-size: 13px;
                        }
                    }
                }

                > label:hover {
                    > .img-box {
                        > img {
                            content: url('./img/check_img_1_hover.svg');
                        }
                    }
                }

                > input:checked + label {
                    > .img-box {
                        > img {
                            content: url('./img/check_img_1_active.svg');
                        }
                    }
                }
            }

            > button {
                margin-left: 4px;
                font-size: 16px;
                color: ${props => props.theme.mainColor1};
                @media (max-width: 1400px) {
                    margin-left: 0.2857vw;
                    font-size: 1.1428vw;
                }
                @media (max-width: 767px) {
                    margin-left: 4px;
                    font-size: 13px;
                }
            }
        }

        .submit-btn {
            margin-top: 24px;
            width: 146px;
            height: 48px;
            border-radius: 8px;
            background: #FAFAFA;
            box-sizing: border-box;
            border: 1px solid #C8C8C8;
            font-size: 18px;
            color: #282828;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                width: 10.4285vw;
                height: 3.4285vw;
                border-radius: 0.5714vw;
                font-size: 1.2857vw;
            }
            @media (max-width: 767px) {
                margin-top: 24px;
                width: 100%;
                height: 48px;
                border-radius: 8px;
                font-size: 16px;
            }
        }
    }

    .right-box {
        width: 39%;
        box-sizing: border-box;
        padding: 40px;
        background: url(./img/contact_img_1.png) no-repeat center center/cover;
        @media (max-width: 1400px) {
            padding: 2.8571vw;
        }
        @media (max-width: 767px) {
            width: 100%;
            padding: 24px 24px 113px 24px;
        }

        > p {
            font-size: 30px;
            line-height: 40px;
            color: #fff;
            @media (max-width: 1400px) {
                font-size: 2.1428vw;
                line-height: 2.8571vw;
            }
            @media (max-width: 767px) {
                font-size: 20px;
                line-height: 28px;
            }
        }
    }
`